import React from 'react';
import { FaTimes } from 'react-icons/fa';
import LazyImage from './LazyImage';

const CloseModal = (props) => {
    const handleClose = (event)=> {
        if(props.onClick){
            props.onClick(event)
        }
    }
    return (
        <button disabled={props.disabled} onClick={handleClose} className="absolute shadow hoverRed bg-red-700 rounded-full w-fit top-1 right-1 z-[11] ">
            {/* <LazyImage className='w-7' src="/img/close.png" alt="close" /> */}
            <FaTimes className=" text-white p-1 h-7 w-7" />
        </button>
    );
}

export default CloseModal;
